module.exports = __webpack_public_path__ + "static/fonts/iconfont.6a815aed.ttf";